import styled, { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`

  html {
    font-size: 10px;
  }

  /* to enable native scrolling for browsers which support native scrolling
    ( https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView )
    as well as to allow 'scroll-container' class elements to allow native scrolling (this is useful for 'smooth-scroll-into-view-if-needed' package)
  */

  html.modal-open {
    overflow: hidden;
  }

  body.moda-open {
    overflow: inherit;
  }

  /* This senses uses's OS's native preferences for scroll, if someone has turned off
    they won't see scroll animation
  */
  @media (prefers-reduced-motion) {
    html,
    .scroll-container {
      scroll-behavior: auto;
    }
  }

  *{
    padding:0;
    margin:0;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }

  .headerBox{
    z-index:99;
  }

  .oh {
    overflow: hidden;
  }

  // body{
  //   background: #dadee3 !important;
  //   color: #141823;
  //   -webkit-font-smoothing: antialiased;
  //   -moz-osx-font-smoothing: grayscale;
  //   font: 400 1.2rem/1.33 Helvetica Neue,Arial,sans-serif !important;
  // }

  button,input{
    font: 400 1.2rem/1.185 'Rubik', sans-serif;
  }

  body{
    background: #dadee3;
    color: #222222;
    font: 400 1.2rem/1.185 'Rubik', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .dn{
    display: none;
  }
  
  .dF{
    display: flex
  }
  .dIF{
    display: inline-flex
  }

  .dib {
    display: inline-block;
  }
  
  .width100{width:100%;}

  .flexWrap{
    flex-wrap: wrap
  }
  .flex1{
    flex: 1
  }
  .flex1_5{
    flex: 1.5
  }
  .flex2{
    flex: 2
  }
  .flex3{
    flex: 3;
  }
  .flexCol{
    display: flex;
    flex-direction: column
  }
  .flexRow{
    display: flex;
    flex-direction: row;
  }

  .justifyCenter{
    justify-content: center
  }
  .justifyStart{
    justify-content: flex-start
  }
  .justifyEnd{
    justify-content: flex-end
  }
  .justifyBetween{
    justify-content: space-between
  }
  .justifyAround{
    justify-content: space-around
  }

  .alignItemsCenter{
    align-items: center
  }
  .alignItemsStart{
    align-items: flex-start
  }
  .alignItemsEnd{
    align-items: flex-end
  }
  .alignItemsBaseline{
    align-items: baseline
  }
  .alignItemsStretch{
    align-items: stretch
  }
  .alignSelfStart{
    align-self: flex-start
  }
  .alignSelfCenter{
    align-self: center
  }

  .fGS0{
    flex-grow:0;
    flex-shrink:0;
  }

  .black{&&{color:#141823;}}
  .white{&&{color:#ffffff;}}
  .green {&&{color: #18a160;}}
  .red {&&{color: #f04949;}}
  .redError{&&{color:#F11919}}
  .drGrey{&&{color:#777777;}}
  .pinkish_orange{color:#ff6d38;}
  .greyLt{color:#dadee3}
  .light_grey{color:#c2c2c2}
  .blueGrey {color: #647a97;}

  .go_blue_bg{background-color:#2276e3;}
  .go_grey_bg{background: #dadee3;}
  .go_orange_bg{background-color:#ff6d38;}
  .light_grey_bg{background-color:#c2c2c2}
  .whiteBg {background-color: #ffffff;}
  .paleGreyBg {background-color: #fafafa;}

  .txtUpper{text-transform:uppercase;}
  .txtCap{text-transform:capitalize;}
  .underLn{text-decoration:underline;}
  .strike {text-decoration: line-through;}

  .fn{font-weight:normal;}
  .hmMed{font-weight: 500;}
  .f500{font-weight: 500;}
  .f600{font-weight:600;}
  .f700{font-weight:700;}

  .font10 {font-size: 1rem;}
  .font11 {font-size: 11px;}
  .font13{font-size:13px;}
  .font14{font-size:14px;}
  .font15{font-size:15px;}
  .font16 {font-size: 1.6rem;}
  .font17 {font-size: 1.7rem;}
  .font18 {font-size: 1.8rem !important;}
  .font20 {font-size: 2rem;}
  .font22 {font-size: 2.2rem;}
  .font24 {font-size: 2.4rem;}

  .ls1{letter-spacing: 1px;}

  .padT2{padding-top: 2px;}
  .padT3 {padding-top: 3px;}
  .padT4 {padding-top: 4px;}
  .padT5{padding-top:0.5rem;}
  .padT10{padding-top:10px;}
  .padT15 {padding-top: 1.5rem;}
  .padT16 {padding-top: 1.6rem;}
  .padT20 {padding-top: 2rem;}
  .padT25{padding-top:25px;}
  .padT35{padding-top:3.5rem;}

  .padB2{padding-bottom: 2px;}
  .padB4 {padding-bottom: 4px;}
  .padB5{padding-bottom:0.5rem;}
  .padB10{padding-bottom:10px}
  .padB15{padding-bottom: 1.5rem;}
  .padB20 {padding-bottom: 2rem;}
  .padB24 {padding-bottom: 2.4rem;}

  .padL2{padding-left:0.2rem;}
  .padL5{padding-left:0.5rem;}
  .padL10 {padding-left: 1rem;}
  .padL12 {padding-left: 1.2rem;}
  .padL20 {padding-left: 2rem;}
  .padL40{padding-left:40px;}

  .padR5{padding-right:0.5rem;}
  .padR10 {padding-right: 1rem;}
  .padR15 {padding-right: 1.5rem;}
  .padR20 {padding-right: 2rem;}

  .pad10{padding:1rem}
  .pad12{padding:1.2rem}
  .pad20{padding:2rem}

  .padTB50{padding:50px 0}
  .padTB3 {padding-top: 0.3rem;padding-bottom: 0.3rem;}

  .padLR15 {padding-left: 15px;padding-right: 15px;}

  .margin15{ margin: 15px; }

  .marginTMinus2{margin-top: -2px;}
  .marginT2{ margin-top: 2px;}
  .marginT3{ margin-top: 3px;}
  .marginT5{ margin-top: 5px;}
  .marginT8{ margin-top: 8px;}
  .marginT10{ margin-top: 10px;}
  .marginT15{ margin-top: 15px;}
  .marginT16{ margin-top: 16px;}
  .marginT20{ margin-top: 20px;}
  .marginT25{ margin-top: 25px;}
  .marginT30 {margin-top: 30px;}

  .marginL2{margin-left:2px;}
  .marginL3{margin-left:3px;}
  .marginL5{margin-left:5px;}
  .marginL10{margin-left:10px;}
  .marginL12{margin-left:12px;}
  .marginL16{margin-left:16px;}
  .marginL20{margin-left: 20px;}

  .marginR4{margin-right: 4px;}
  .marginR5{margin-right:5px;}
  .marginR7{margin-right:7px;}
  .marginR10{margin-right:10px;}
  .marginR12{margin-right:12px;}
  .marginR15{margin-right:15px;}
  .marginR30{margin-right:30px;}
  
  .marginB2{margin-bottom: 2px;}
  .marginB3{margin-bottom: 3px;}
  .marginB5{margin-bottom: 5px;}
  .marginB8 {margin-bottom: 8px;}
  .marginB10 {margin-bottom: 10px;}
  .marginB12 {margin-bottom: 12px;}
  .marginB20{margin-bottom:20px;}
  .marginB30 {margin-bottom: 30px;}

  .marginTB20 {margin-top: 20px; margin-bottom: 20px;}
  .marginT20{margin-top:20px;}

  .marginB4{margin-bottom:4px;}
  .marginB8{margin-bottom:8px;}
  .marginB15{margin-bottom:15px;}
  .marginB30{margin-bottom:30px;}

  .txtRight{text-align:right;}
  .txtCenter{text-align:center;}

  .padLR5{padding-left:5px;padding-right:5px}
  .padLR20 {
    padding-left: 20px;
    padding-right: 20px;
  }

  .truncate{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height:1.3;
  }

  .maxWid80{max-width:80%;}
  .wid85{width:85%;}
  .width65{width:65%;}
  .width48{width:48%;}
  .width50{width:50%;}
  .wid70{width:70%;}
  .width80{width:90%}
  .wid15{width:15%;}
  .wid40{width:40%;}
  .wid45{width:45%;}
  .wid35-5{width:35.5%;}
  .wid25{width:25%;}
  .wid26{width:26%;}
  .wid33-3{width:33.333%;}
  .wid78{width:78%;}
  .wid60{width:60%;}
  
  
  .brdrBot{border-bottom:1px solid #F0F0F0;}
  .borderTop {border-top: 1px solid #e6e6e6;}
  .BrdrBotDsh {border-bottom: 1px dashed #cbcbcb;}
  .btnBrdr{
    border: none;
    border-radius: 8px;
  }
  
  .brdrRd10 {border-radius: 10px;}
  .br50 {border-radius: 50%;}

  .posRel{position:relative;}
  .posAbs{position:absolute;}

  .clr{clear:both}

  .curPointFlt {cursor: pointer;}

  a {
    color: #166bd3;
    cursor: pointer;
    outline: none;
    text-decoration: none;
  }

  .lh1-2 {line-height: 1.2;}

  .vh {visibility: hidden;}

  *:after,
  *:before {
    box-sizing: border-box;
  }

  .opacity75{opacity:0.75;}
  .op0-5{opacity:0.5;}
  .op0-7{opacity:0.7;}
  .op0{opacity:0;}
  
  .disable{
    pointer-events: none;
    cursor: not-allowed;
    color: #666;
  }

  .rotate180 {transform: rotate(180deg);}

  .blur {
    filter: blur(4px);
  }

  .lh1 {
    &&{
    line-height: 1;
    }
  }

  .bgProperties {
    background-repeat: no-repeat;
    background-position: center;
    display: inline-block;
    background-size: contain;
  }

  .marginR8{margin-right:8px;}

  .sticky{
    top: 0;
    z-index: 2;
    position: sticky !important;
  }

  @media (min-width: 320px) and (max-width: 767px)
  {
    .mobdn {
      display: none;
    }
  }
 
  @media  (min-width: 767px)
  {
    .lgDn.lgDn {
      display: none;
    }
  }
  .lineHeight14{
    line-height: 14px;
  }
  /* new color theme */
  .drGrey{
    &&{
      color:#777777;
    }
  }
  .green {
    &&{
      color: #18a160;
    }
  }
  .redSecondaryBg{
    background-color:#ff3a5c;
  }  
  .yellowBg{
    background-color:#fff6e5;
  }
  .blueBg{
    background-color:#e5f3ff;
  }
  .redBg{
    background-color:#FFEDED;
  }
  .greyCnt{
    color:#717171;
  }
  .greyCntLt{
    color:#b0b0b0;
  }
  .greyCntDrk{
    color:#4f525a;
  }
  .blackCnt{
    color:#222222;
  }
  .blueCnt{
    color:#2276e3;
  }
  .TealCnt{
    color:#00A2AD;
  }
  .greenGlow {
    &&{
     color: #61C558;
    }
  }
`;
